export default __webpack_public_path__ + "src/assets/images/mcvs_acc_opt_hrz_121_1x.png";